exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2hBCQptJ3RdG2u-d9RQEtX{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}._3Ppts6Ve8JU0484c-E2dgE{color:\"[theme:neutralPrimary, default:#333333]\"}html[dir] ._3Ppts6Ve8JU0484c-E2dgE{margin:0 8px}", ""]);
// Exports
exports.locals = {
	"moveToFocusedOtherMenuItems": "_2hBCQptJ3RdG2u-d9RQEtX",
	"moveToInboxPlusPivotIcon": "_3Ppts6Ve8JU0484c-E2dgE"
};